import * as yup from "yup";

export const institutionSchema = yup.object().shape({
  name: yup.string().required().trim(),
  securityDeposit: yup.number().positive().required(),
});
